import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { ISlideProps, ISlideData, DeltaOf, DataModelChange } from '@tencent/slide-sdk-model';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { FillConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/fill/fill-converter';
import {
    DataModelCommonConverter,
} from '@src/slide/domain/ui-model/converter/node-property/module-property/data-model-common/model-id-type-converter';
import _set from 'lodash/set';
import {
    TransitionPropertyConverter,
} from '@src/slide/domain/ui-model/converter/node-property/page/transition-property-converter';
import { ICTSlideTransition } from '@tencent/slide-sdk-pb-model';
import { SlideCommentConverter } from '../module-property/comment/slide-comment-converter';
import { ICommentGroupMap } from '@tencent/slide-sdk-model/src/data/comment-data';
import {
    PictureInfoConverter,
} from '@src/slide/domain/ui-model/converter/node-property/module-property/picture-info/picture-info-converter';

export class SlidePropertyConverter {
    /**
     * 数据3.0转换接口
     * @param sdkData
     * @param uiData
     */
    // eslint-disable-next-line complexity
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepPartial<ISlideProps>,
        uiData: ISlideModel,
        change?: DataModelChange,
    ): void {
        DataModelCommonConverter.convertPartialDataFromSdkToUi(sdkData, uiData);
        if (sdkData.show !== undefined) {
            uiData.isShowInPlay = sdkData.show;
        } else {
            uiData.isShowInPlay = true;
        }
        if (sdkData.cSld?.bg?.bgPr) {
            // 填充
            if (FillConverter.needConvertSdkData(sdkData.cSld?.bg?.bgPr)) {
                // 对齐以前逻辑，每次都重新覆盖一个新对象
                uiData.props.style.fillBackground = {};
                FillConverter.convertPartialDataFromSdkToUi(sdkData.cSld?.bg?.bgPr, uiData.props.style.fillBackground);
                // 设置图片填充， 效果、矫正、重新着色没在fillBackground下，放在了image下
                if (sdkData.cSld.bg.bgPr.blipFill) {
                    uiData.props.style.image = uiData.props.style.image || {};
                    PictureInfoConverter.convertImageImgPropsDataSdkToUi(
                        sdkData.cSld.bg.bgPr.blipFill,
                        uiData.props.style.image,
                    );
                    PictureInfoConverter.convertRecolorDataSdkToUi(
                        sdkData.cSld.bg.bgPr.blipFill,
                        uiData.props.style.image,
                    );
                } else if (uiData.props.style.image) {
                    delete uiData.props.style.image;
                }
            }
        }

        // layoutId
        if (sdkData.layoutId) {
            uiData.layoutId = sdkData.layoutId;
        }

        // 是否显示背景图形（虽然目前只有layout有入口）
        uiData.showMasterSp = (sdkData.showMasterSp ?? 1) ? 1 : 0;

        if (sdkData.transition) {
            uiData.transition = TransitionPropertyConverter
                .convertPartialDataFromSdkToUi(sdkData.transition as DeepReadonly<ICTSlideTransition>);
        } else {
            uiData.transition = undefined;
        }

        const diffCommentGroupMap = (change?.diffs as any)?.data?.commentGroupMap;
        if ((!change || diffCommentGroupMap) && sdkData.commentGroupMap) {
            SlideCommentConverter.convertPartialDataFromSdkToUi(
                sdkData.commentGroupMap as DeepReadonly<ICommentGroupMap>,
                uiData,
                // @ts-ignore
                sdkData?.data?.cSld?.spTree?.shapeList,
                diffCommentGroupMap,
            );
        }
    }

    public static convertPartialDataFromUiToSdk(
        uiData: DeepPartial<ISlideModel>,
        sdkData: DeltaOf<ISlideData>,
    ): void {
        DataModelCommonConverter.convertPartialDataFromUiToSdk(uiData, sdkData);
        if (uiData.props?.style?.fillBackground) {
            if (!sdkData.cSld?.bg?.bgPr) {
                _set(sdkData, 'cSld.bg.bgPr', {});
            }
            // @ts-ignore
            FillConverter.convertPartialDataFromUiToSdk(uiData.props?.style?.fillBackground, sdkData.cSld.bg.bgPr);
            const bgPrNotEmpty = Object.values(sdkData?.cSld?.bg?.bgPr || {}).some(e => !!e);
            if (!bgPrNotEmpty) {
                _set(sdkData, 'cSld.bg', null);
            }
        } else if (uiData.props?.style?.fillBackground === null) {
            _set(sdkData, 'cSld.bg', null);
        }

        // 上层在convert的时候，updateProps的参数都放到了props下，这里需要去判断props下的transition
        if (uiData.props?.transition) {
            _set(sdkData, 'transition', TransitionPropertyConverter.convertPartialDataFromUiToSdk(uiData.props.transition));
        } else if (uiData.props?.transition === null) {
            _set(sdkData, 'transition', null);
        }

        SlideCommentConverter.convertPartialDataFromUiToSdk(uiData, sdkData);
    }
}
